import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Para qué edades son las actividades?',
  answer: 'El pack está pensado principalmente para familias con niños de 4 a 12 años. Sin embargo, muchas de las actividades y preguntas de conexión son adaptables y disfrutables para adolescentes e incluso solo entre adultos.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Inmediatamente después de tu compra recibís un email con el enlace de descarga. Todo el material es 100% digital en formato PDF de alta calidad. Cada cita tiene espacio para pegar fotos y anotar recuerdos. Podés verlas desde tu celular/tablet o imprimirlas (incluimos instrucciones para impresión).'
}, {
  question: '¿Necesito comprar materiales extra?',
  answer: '¡No! Las citas están pensadas para crear recuerdos con lo que ya tenés en casa o sin necesidad de materiales. Cada cita incluye espacio para pegar fotos y anotar lo que vivieron juntos.'
}, {
  question: '¿Qué lo diferencia de otros productos similares?',
  answer: 'Este pack es un sistema completo de 100 citas diseñadas para fortalecer el vínculo familiar. No son tips sueltos ni ideas genéricas. Cada cita está pensada para crear un momento real de conexión, con espacio para fotos y recuerdos que van armando un álbum familiar único.'
}, {
  question: '¿Tiene garantía real?',
  answer: 'Sí. Tenés 7 días completos para probarlo. Si no es lo que esperabas, te devolvemos el 100% del dinero sin preguntas, sin formularios, sin drama. Nuestra prioridad es que sume valor a tu familia.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 px-4 bg-gray-50" data-id="element-104">
      <div className="max-w-3xl mx-auto" data-id="element-105">
        <div className="text-center mb-12" data-id="element-106">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-107">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
          <div className="w-24 h-2 bg-blue-600 mx-auto rounded-full" data-id="element-108"></div>
        </div>

        <div className="space-y-3" data-id="element-109">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-110">
              <button onClick={() => toggle(index)} className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer" data-id="element-111">
                <span className="text-lg md:text-xl font-bold text-gray-900 pr-4" data-id="element-112">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 md:w-6 md:h-6 text-gray-500 flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-113" />
              </button>
              {openIndex === index && <div className="px-5 md:px-6 pb-5 md:pb-6" data-id="element-114">
                  <p className="text-base md:text-lg text-gray-600 font-medium leading-relaxed" data-id="element-115">
                    {faq.answer}
                  </p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}